import * as l from "react";
const e = (a) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.328 3.136l.027-.07-.001-.001-.003-.002-.01-.003-.03-.011a10.754 10.754 0 00-.476-.157c-.317-.096-.767-.22-1.313-.332-1.086-.224-2.586-.413-4.19-.242-1.61.171-3.358.708-4.882 1.965-1.531 1.263-2.756 3.186-3.423 5.985a1 1 0 001.946.464c.583-2.45 1.608-3.965 2.75-4.906 1.025-.846 2.21-1.28 3.398-1.464-.462.351-.88.786-1.221 1.32-.58.905-.9 2.034-.9 3.399 0 2.88 1.455 4.898 3.071 6.162a9.693 9.693 0 002.417 1.379c.74.289 1.464.459 2.012.459a1 1 0 00.535-.155l1.522-.962a1 1 0 011-.04l1.977 1.042a1 1 0 10.932-1.77l-1.976-1.041a3 3 0 00-3.002.118l-1.24.784a5.174 5.174 0 01-1.032-.298 7.692 7.692 0 01-1.912-1.09C11.045 12.682 10 11.2 10 9.08c0-1.044.242-1.785.585-2.321.332-.52.797-.904 1.354-1.181-.28.685-.439 1.515-.439 2.502 0 1.01.175 1.849.526 2.526.36.692.873 1.16 1.448 1.46 1 .523 2.176.518 2.877.514h.149a1 1 0 00.476-.12l.997-.54a1 1 0 01.99.023l1.522.913a1 1 0 001.03-1.714l-1.523-.914a3 3 0 00-2.97-.067l-.774.419c-.722-.003-1.354-.028-1.847-.286a1.363 1.363 0 01-.6-.609c-.164-.316-.301-.816-.301-1.605 0-1.572.498-2.288.929-2.625a1.968 1.968 0 011.388-.39l.05.006A1 1 0 0017 4.042a1 1 0 00-.643-.977l-.027.071zm-3.977 17.371a1 1 0 00-1.072.037l-.895.612a3 3 0 01-3.05.2l-1.561-.79a1 1 0 00-1.178.204l-.869.918a1 1 0 01-1.452-1.376l.87-.917a3 3 0 013.533-.613l1.56.79a1 1 0 001.017-.066l.895-.613a3 3 0 013.218-.109l1.295.763a1 1 0 001.006.005l1.248-.718a3 3 0 013.433.307l1.296 1.095a1 1 0 11-1.29 1.528l-1.296-1.095a1 1 0 00-1.145-.102l-1.248.718a3 3 0 01-3.02-.015l-1.295-.763z",
      fill: "#2d6ded"
    }
  )
), t = e;
export {
  t as default
};
